import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { IonSkeletonText } from '@ionic/angular/standalone';
import { QRCodeComponent } from 'angularx-qrcode';
import { ThemePipe } from 'src/app/core/pipes/theme.pipe';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ButtonComponent } from 'src/app/ui/buttons/button/button.component';
import { PaymentDrawerStyles } from '../../payment-drawer/payment-drawer-styles';

/**
 * A Lightning invoice the player pays from another device or copies: "Scan QR to pay" and the QR
 * when `showQR`, then Copy invoice. Until the invoice arrives, "Preparing invoice…" says why Copy
 * and the host's Pay are spinning, and the QR is a skeleton. Renders from plain values and
 * reports the copy tap, so the host's payment owns the invoice and the copy. `stacked` puts the
 * status over the QR and Copy under it; `row` puts the QR beside the status and Copy.
 */
@Component({
  selector: 'app-lightning-invoice-panel',
  templateUrl: './lightning-invoice-panel.component.html',
  styleUrls: ['./lightning-invoice-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.row]': "layout() === 'row'" },
  imports: [
    NgStyle,
    NgTemplateOutlet,
    TranslocoDirective,
    IonSkeletonText,
    QRCodeComponent,
    ButtonComponent,
    ThemePipe,
  ],
})
export class LightningInvoicePanelComponent {
  // Undefined until the invoice arrives; the QR and Copy wait for it.
  readonly invoice = input<string>();
  // True on desktop web, where the player scans the invoice from another device.
  readonly showQR = input.required<boolean>();
  readonly qrWidth = input.required<number>();
  readonly layout = input<'stacked' | 'row'>('stacked');
  readonly copyClickedEvent = output<void>();

  protected readonly themeService = inject(ThemeService);
  protected readonly PaymentDrawerStyles = PaymentDrawerStyles;
}
